
import { useState, useEffect, useRef } from 'react';
import './RegionSelector.css';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg?react';
const RegionSelector = ({ 
  selectedRegion, 
  onRegionSelect, 
  jejuRegionData,
  sigunguList,
  eupmyeondongList,
  isRounded = false,
  isAbsolute = false,
  compact = false 
}) => {
  // 시군구 목록을 중복 제거하여 생성
  const uniqueSigunguList = [...new Set(sigunguList)];
  
  // 선택된 시군구에 따른 읍면동 목록 필터링
  const filteredEupmyeondongList = selectedRegion.sigungu 
    ? eupmyeondongList.filter(item => {
        const regionData = jejuRegionData.find(data => 
          data.RegionSigungu === selectedRegion.sigungu && 
          data.RegionEupMyuonDong === item
        );
        return regionData;
      })
    : [];
  const [isSigunguOpen, setIsSigunguOpen] = useState(false);
  const [isEupmyeondongOpen, setIsEupmyeondongOpen] = useState(false);
  
  // 스크롤을 위한 ref
  const sigunguColumnRef = useRef(null);
  const eupmyeondongColumnRef = useRef(null);

  // 시군구 선택시 읍면동 드롭다운 열기 (사용자가 직접 선택했을 때만)
  // useEffect(() => {
  //   if (selectedRegion.sigungu) {
  //     setIsEupmyeondongOpen(true);
  //   }
  // }, [selectedRegion.sigungu]);

  // 선택된 항목으로 스크롤
  useEffect(() => {
    if (isSigunguOpen && selectedRegion.sigungu && sigunguColumnRef.current) {
      // 시군구 컬럼에서 선택된 항목으로 스크롤
      const selectedElement = sigunguColumnRef.current.querySelector(`[data-value="${selectedRegion.sigungu}"]`);
      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  }, [isSigunguOpen, selectedRegion.sigungu]);

  useEffect(() => {
    if (isEupmyeondongOpen && selectedRegion.eupmyeondong && eupmyeondongColumnRef.current) {
      // 읍면동 컬럼에서 선택된 항목으로 스크롤
      const selectedElement = eupmyeondongColumnRef.current.querySelector(`[data-value="${selectedRegion.eupmyeondong}"]`);
      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  }, [isEupmyeondongOpen, selectedRegion.eupmyeondong]);

  const handleSigunguClick = () => {
    setIsSigunguOpen(!isSigunguOpen);
    if (isSigunguOpen) {
      setIsEupmyeondongOpen(false);
    }
  };

  const handleEupmyeondongClick = () => {
    setIsEupmyeondongOpen(!isEupmyeondongOpen);
  };

  const handleSigunguSelect = (sigungu) => {
    onRegionSelect({
      sido: selectedRegion.sido,
      sigungu: sigungu,
      eupmyeondong: '' // 시군구 선택 시 읍면동 초기화
    });
    setIsSigunguOpen(false);
    // 시군구를 선택했을 때만 읍면동 드롭다운 열기 (빈 값이 아닐 때)
    if (sigungu) {
      setIsEupmyeondongOpen(true);
    } else {
      setIsEupmyeondongOpen(false);
    }
  };

  const handleEupmyeondongSelect = (eupmyeondong) => {
    onRegionSelect({
      sido: selectedRegion.sido,
      sigungu: selectedRegion.sigungu,
      eupmyeondong: eupmyeondong
    });
    setIsEupmyeondongOpen(false);
  };

  return (
    <div className={`region-selector ${isAbsolute ? 'absolute' : ''} ${isRounded ? 'rounded' : ''} ${compact ? 'compact' : ''}`}>
      {/* 헤더 바 */}
      <div className="region-header">
        <div className="region-header-item">
          <span className="region-label">제주특별자치도</span>
        </div>
        <div 
          className={`region-header-item ${isSigunguOpen ? 'active' : ''}`}
          onClick={handleSigunguClick}
        >
          <span className="region-label">
            {selectedRegion.sigungu || '시군구'}
          </span>
          <span className={`region-selector-chevron chevron ${isSigunguOpen ? 'up' : 'down'}`}><ChevronDownIcon /></span>
        </div>
        <div 
          className={`region-header-item ${isEupmyeondongOpen ? 'active' : ''}`}
          onClick={handleEupmyeondongClick}
        >
          <span className="region-label">
            {selectedRegion.eupmyeondong || '동/읍/면'}
          </span>
          <span className={`region-selector-chevron chevron ${isEupmyeondongOpen ? 'up' : 'down'}`}><ChevronDownIcon /></span>
        </div>
      </div>

      {/* 드롭다운 패널 */}
      {(isSigunguOpen || isEupmyeondongOpen) && (
        <div className={`region-dropdown-panel ${isAbsolute ? 'absolute' : ''}`}>
          {/* 시도 컬럼 */}
          <div className="region-column">
            <div className="region-option selected">제주특별자치도</div>
          </div>

          {/* 시군구 컬럼 */}
          {(isSigunguOpen ||  isEupmyeondongOpen) && (
            <div className="region-column" ref={sigunguColumnRef}>
              <div 
                className="region-option"
                data-value=""
                onClick={() => handleSigunguSelect('')}
              >
                전체
              </div>
              {uniqueSigunguList.map((sigungu) => (
                <div 
                  key={sigungu}
                  className={`region-option ${selectedRegion.sigungu === sigungu ? 'selected' : ''}`}
                  data-value={sigungu}
                  onClick={() => handleSigunguSelect(sigungu)}
                >
                  {sigungu}
                </div>
              ))}
            </div>
          )}

          {/* 읍면동 컬럼 */}
          {isEupmyeondongOpen && selectedRegion.sigungu && (
            <div className="region-column" ref={eupmyeondongColumnRef}>
              <div 
                className="region-option"
                data-value=""
                onClick={() => handleEupmyeondongSelect('')}
              >
                전체
              </div>
              {filteredEupmyeondongList.map((eupmyeondong) => (
                <div 
                  key={eupmyeondong}
                  className={`region-option ${selectedRegion.eupmyeondong === eupmyeondong ? 'selected' : ''}`}
                  data-value={eupmyeondong}
                  onClick={() => handleEupmyeondongSelect(eupmyeondong)}
                >
                  {eupmyeondong}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RegionSelector;